import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderNumberField, required } from '../../utils/formValidation';

import '../form.css';

// this needs to be brought out of redux-form

const SchoolEmploymentForm = props => {
  const { handleSubmit } = props;

  return (
    <form className="oshaEmploymentForm" onSubmit={handleSubmit}>
      <div className="form-fields">
        <Field
          name="numberOfTeachersInstructors"
          component={renderNumberField}
          label="Teachers/Instructors."
          placeholder={0}
          requiredLabel={true}
          validate={[required]}
        />
        <Field
          name="numberOfAllOtherSupportStaff"
          component={renderNumberField}
          label="All others/support staff."
          placeholder={0}
          requiredLabel={true}
          validate={[required]}
        />
      </div>
    </form>
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default reduxForm({
  form: 'SchoolEmploymentForm'
})(SchoolEmploymentForm);
